// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1322":"56196209","5222":"b68a9676","5729":"8c6d89f4","9464":"94f64ab8"}[chunkId] + ".chunk.css";
};